import Http from './http'

class ItemService {
  constructor() {
    this.itemsUrl = '/items'
  }

  getByObraId(id) {
    return Http.get(`${this.itemsUrl}/obra/${id}`)
  }

  edit(id, data) {
    return Http.put(`${this.itemsUrl}/${id}`, data)
  }

  addItem(obra_id) {
    const req = { obra_id }
    return Http.post(`${this.itemsUrl}`, req)
  }
}

export default new ItemService()
